import { Text } from "@shopify/polaris";

export const AddressBlock = ({ location, label }) => location
    ? (
        <div>
            <h3><Text  variant="bodyMd" as="span" fontWeight="semibold">{ label }</Text></h3>
            {location.company && <>{location.company}<br /></>}
            {location.address1}<br />
            {location.address2}<br />
            {location.city}, {location.state} {location.zip_code}
            <p>
                { location.type && <div><Text  variant="bodyMd" as="span" fontWeight="semibold">Type:</Text> {location.type || 'Not Defined'}</div>}
            </p>
        </div>
    )
    : null;
